import { CommonModule, NgFor, NgIf, NgSwitch } from '@angular/common';
import { Component, ViewChild,OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as d3 from 'd3';
import { DEVICE_CONFIGS, MetricOption, DateRangeOption, DeviceHistoryRecord, TelemetryDetails, TelemetryValue,TelemetryDetailsWithoutGauge, DeviceDetais, GpioConfig, GaugeChartInterface, aggregationFilterInterface, ImageDetail } from 'src/app/models/common/device-telemetry-model';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { ControllerService } from 'src/app/services/controller.service';
import { FormsModule } from '@angular/forms';
import { DateTime } from 'luxon';
import { SideBarComponent } from "../../../../components/side-bar/side-bar.component";
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { ControllerDetails, ControllerInfo } from 'src/app/models/common/controller-info.model';
import { AlarmDashboardComponent } from '../../alarm-dashboard/alarm-dashboard.component';
import { ActionHistoryDashboardComponent } from '../../action-history-dashboard/action-history-dashboard.component';
import { RouteConstants } from 'src/app/constants/route-constants';
import {MatDatepicker, MatDatepickerInput, MatDatepickerModule, MatDateRangeInput, MatDateRangePicker} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {provideNativeDateAdapter} from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CustomerCardComponent } from "../customer-dashboard/customer-card/customer-card.component";


@Component({
  selector: 'app-device-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule, NgFor, NgIf, NgSwitch, SideBarComponent, AlarmDashboardComponent, ActionHistoryDashboardComponent, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatSelectModule, CustomerCardComponent],
  providers: [provideNativeDateAdapter()],
  templateUrl: './device-dashboard.component.html',
  styleUrls: ['./device-dashboard.component.css'],
  
})
export class DeviceDashboardComponent implements OnInit{
  streamCalled: boolean = false;
  telemetryView:boolean = false
  otherFields:number = 0
  name = 'datepicker';
  telemetryDetails?:TelemetryDetailsWithoutGauge
  setParams:number = 0
  historyScreenBool:boolean = false
  deviceDetails!:DeviceDetais
  statusDevice:string | undefined = ""
  showTelemeteryForDevices = ["SaltChlorinator","VsPump","DosingPump","HeatPump","HeatPumpSg"]
  showDatePicker = ["Cell life","Pool cover","Status","Motor speed","Power consumption"]
  device_status = ["turn_on","turn_off"]
  spinner:boolean = true
  startDate!: Date | null | undefined ;
  endDate!:Date | null | undefined ;
  previousDate = new Date(new Date().getFullYear(), 0, 1);
  maxDate = new Date()
  planModel: Date = new Date(new Date().setHours(0, 0, 0, 0) );
  // controllerList: Controller[] = [];
  deviceHistory :  DeviceHistoryRecord[] = [];
  currentDeviceStatus:string  = ""
  encryptedUserId:string = ""
  @ViewChild('datepicker')datepicker?:MatDatepicker<Date>


  device_id: string = "";
  showCustomerPopUp = false
  controller_uuid: string = "";
  noData: boolean = false
  alarms:boolean = false
  isAdmin:boolean = false
  showAlarmPopup: boolean = false;
  showActionPopUp: boolean = false;
  changeDateFormat: boolean = false;
  availableMetrics: MetricOption[] = [];
  selectedMetric: MetricOption | null = null;
  availableDateRanges: DateRangeOption[] = [];
  copyAvailableDateRange:DateRangeOption[] = [];
  controllerDetails!:ControllerDetails
  todayDate:Date = new Date();
  gaugeUnit!: ImageDetail;



  reloaded: number = 0;


  selectedDateRange?: DateRangeOption;
  controller_info?:ControllerInfo
  // selectedDateRange!: DateRangeOption;

  constructor(
    private auth: AuthserviceService,
    private controller: ControllerService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  onApplyClick(dateRangeInput: MatDateRangeInput<Date> | undefined ,inputRange:MatDatepickerInput<Date>| undefined){ 
    if(dateRangeInput){
      this.startDate = dateRangeInput.value?.start
      this.endDate = dateRangeInput.value?.end
    }
    else{
      this.startDate  = inputRange?.value
      this.endDate = undefined
    }
    if (this.selectedMetric && this.selectedDateRange){
    const { start, stop, aggregate_filter } = this.getDateRange(this.selectedDateRange.label, this.selectedDateRange.aggregate_filter,this.startDate,this.endDate);
    this.getDeviceSpecificHistory(
      this.controller_uuid,
      this.device_id,
      this.selectedMetric.value,
      start,
      stop,
      aggregate_filter,
      this.selectedDateRange.label,
      this.selectedMetric.graph_type,
      this.selectedMetric.graph_value
    );
    }

  }

  getDeviceClass(){
    return {
      aux: this.statusDevice === 'turn_on' && this.device_id.includes('Aux'),
      uv: this.statusDevice === 'turn_on' && this.device_id.includes('UvLamp'),
      PoolLight:this.statusDevice === 'turn_on' && this.device_id.includes('PoolLight'),
      watermeter:this.device_id.includes('WaterMeter') && this.selectedMetric!.label === "Reverse cumulative flow"
    };
  }






  getTelemtryDetails(){
    this.telemetryView = true
    this.planModel = new Date(new Date().setHours(0, 0, 0, 0) );
    this.historyScreenBool = false
    d3.selectAll("svg").remove();
    this.getDeviceSpecificTelemetry(this.selectedMetric)
    
  }

  async gaugeChart(gaugeParameters:GaugeChartInterface): Promise<void> {
      this.telemetryView = true
      this.spinner = true
      const deviceStatus:DeviceDetais | undefined= await this.deviceStatus()
      const valueSelected = gaugeParameters.selectedValue?.value
      const labelSelected = gaugeParameters.selectedValue?.label
      let colour =  ["#000000b10","#00000010"]
      const colour_inner = ["rgba(226, 104, 104, 1)","rgba(41, 206, 148, 1)","rgba(226, 104, 104, 1)"]
      const telemetryDetails:TelemetryDetails = await this.controller.telemeteryGet(this.controller_uuid,this.device_id,gaugeParameters.fieldList)
      this.spinner = false
      const result:TelemetryValue[] = telemetryDetails.result
      const outerDat = this.selectedParametersFiltering(result,valueSelected)

      const svg = d3.select(`#chart`).append("svg").attr("id","gauge").attr("viewBox", "0 0 800 700")
   .style("width", "100%") 
      .style("height", "auto")
      .append("g")
      .attr("transform", "translate(409, 250) rotate(-90)");

      if(deviceStatus?.device_status == "turn_on"){
        colour = ["rgba(255, 217, 88, 1)","rgba(255, 255, 255, 0.05)"]
        var defs = svg.append('defs');
        var filter = defs.append('filter')
                    .attr('id', 'drop-shadow')
                    .attr('height', '130%');
  
        filter.append('feGaussianBlur')
        .attr('in', 'SourceAlpha')
        .attr('stdDeviation', 4)
        .attr('result', 'blur');
  
        filter.append('feOffset')
        .attr('dx', 0)
        .attr('dy', 2)
        .attr('result', 'offsetBlur');
  
        filter.append('feFlood')
        .attr('flood-color', 'rgba(255, 217, 88, 0.42)').attr('flood-opacity', '1')
        .attr('result', 'floodFill');
      
        filter.append('feComposite')
        .attr('in', 'floodFill').attr('in2','offsetBlur').attr('operator','in')
        .attr('result', 'coloredShadow');

        var feMerge = filter.append('feMerge');
        
        feMerge.append('feMergeNode')
          .attr('in', 'coloredShadow')
        feMerge.append('feMergeNode')
          .attr('in', 'SourceGraphic');
            }
      
     

  
    const arcWidth = gaugeParameters.arcWidth
    const gaugeSegmentModel = gaugeParameters.gaugeSegmentModel
    svg.append("text").text(`${this.otherFields.toFixed(1)} ${this.gaugeUnit?.unit}`).style("-webkit-transform", "rotate(-270deg)").attr("fill", "rgba(255, 255, 255, 1)").attr("text-anchor", "middle").attr("dominant-baseline", "middle") .attr("font-size","30").attr('y',gaugeParameters.yAxis)
    svg.append("text").text(labelSelected).style("-webkit-transform", "rotate(-270deg)").attr("fill", "rgba(255, 255, 255, 1)").attr("text-anchor", "middle").attr("dominant-baseline", "middle").attr('y',gaugeParameters.yAxisLabel)
    svg.append("text").text("0").attr("class","text-style").style("-webkit-transform", "rotate(-270deg)").attr('x',-165).attr('y',30).attr("fill", "rgba(255, 255, 255, 1)")
    svg.append("text").text(arcWidth).attr("class","text-style").style("-webkit-transform", "rotate(-270deg)").attr('x',156).attr('y',30).attr("fill", "rgba(255, 255, 255, 1)")
   
      if(this.otherFields > arcWidth){
        this.otherFields = arcWidth
      }
      const pie = d3.pie()
      .value(d=> Number(d))
      .startAngle(0)
      .endAngle(Math.PI)
      .sort(null);

      const outerArcData:d3.PieArcDatum<number | { valueOf(): number;}>[] = pie(outerDat)
      const innerData = gaugeSegmentModel 
      const endAngle = (Number(this.setParams)/arcWidth)*3.14
      if(outerArcData.length >1){
      outerArcData[1].startAngle = 0
      outerArcData[1].endAngle = endAngle
      }
      outerArcData[0].startAngle = 0
      outerArcData[0].endAngle = (Number(this.otherFields)/arcWidth)*3.14 
      const outerArc:any = d3.arc<d3.PieArcDatum<{}>>()
        .padAngle(0) 
          .innerRadius(160)
          .outerRadius(170)
          .cornerRadius(25)
          ;
      const background =  d3.arc<d3.PieArcDatum<{}>>()
        .padAngle(0) 
          .innerRadius(170)
          .outerRadius(160)
          .cornerRadius(25)
          ;
      const innerArc = d3.arc<d3.PieArcDatum<{}>>()
          .innerRadius(145)
          .outerRadius(150)
          .cornerRadius(10)
          .padAngle(0.046) ;

        // Draw outer semicircle segments
      svg.selectAll(".background")
        .data(pie([100]))
        .enter()
        .append("path")
        .attr("class", "background")
        .attr("d", background)
        .attr("stroke-linecap", "round")
        .attr("fill", "rgba(255, 255, 255, 0.29)")
      
      // Then: draw the foreground segments
      svg.selectAll(".outer")
        .data(outerArcData)
        .enter()
        .append("path")
        .attr("class", "outer")
        .attr("d", outerArc)
        .attr("stroke-linecap", "round").attr('filter', 'url(#drop-shadow)')
        .attr("fill", (d, i) => colour[i]) 

      if(innerData){
          svg.selectAll(".inner")
            .data(pie(innerData))
            .enter()
            .append("path")
            .attr("class", "inner")
            .attr("d", innerArc)
            .attr("fill", (d, i) => colour_inner[i]);
          }
        
          const x = 190 * Math.cos(endAngle - Math.PI / 2); // Adjust because 0° is vertical
          const y = 190 * Math.sin(endAngle - Math.PI / 2);
        let textParams =  svg.append("text")
          .attr("x", x)
          .attr("y", y)
          .attr('class','ssksksksksk')
          .attr("text-anchor", "middle")
        
        if(this.setParams){
          textParams.text(this.setParams ).attr("refY", 1000).attr("fill", "rgba(255, 255, 255, 1)")
          .attr("transform", `rotate(89, ${x+4}, ${y+4}) translate(0,8)`);
      
          d3.select("svg")
          .append("defs")
          .append("marker")
            .attr("id", "triangle")
            .attr("viewBox", "0 0 10 10")
            .attr("refX",15)  // where the point is placed relative to the needle
            .attr("refY", 5)
            .attr("markerWidth", 10)
            .attr("markerHeight", 10)
            .attr("orient", "auto")
            .append("path")
              .attr("d", "M 0 0 L 10 5 L 0 10 z")  // triangle shape
              .attr("fill", "rgba(41, 206, 148, 1)")
                .attr("marker-end", "url(#triangle)");
                
          d3.select("svg")
          .append("defs")
          .append("marker")
            .attr("id", "circlePointer")
            .attr("viewBox", "0 0 10 10")
            .attr("refX", 30)  // Position of the center of the marker relative to the line
            .attr("refY", 5)  // Position of the center of the marker relative to the line
            .attr("markerWidth", 7)
            .attr("markerHeight", 10)
            .attr("orient", "auto")
            .append("circle")
              .attr("cx", 5)  
              .attr("cy", 5)  
              .attr("r", 2)   
              .attr("fill", "rgba(255, 255, 255, 1)");
          svg.append("line")
              .attr("x1", 0)
              .attr("y1", 0)
              .attr("x2", x)
              .attr("y2", y)
              .attr("stroke-width", 2)
              .attr("marker-end", "url(#triangle)")
          
          svg.append("line")
              .attr("x1", 0)
              .attr("y1", 0)
              .attr("x2", x)
              .attr("y2", y)
              .attr("stroke-width", 2)
              .attr("marker-end", "url(#circlePointer)");
    
          
        }
        let translatX = 0

        if (this.device_id == "VsPump"){
          textParams.text(this.setParams ).attr("refY", 1000).attr("fill", "rgba(255, 255, 255, 1)")
          .attr("transform", `rotate(89, ${x+4}, ${y+4}) translate(15,8)`);
          
          
         
        const degrees = outerArcData[0].endAngle * (180 / Math.PI)
        const angle = degrees  + 90
        svg.append("path").attr("d","M 102.6193 113.6644 C 103.373 115.2146 104.5705 116.5068 106.0587 117.3768 C 107.5469 118.2468 109.2603 118.6561 110.9812 118.5526 C 112.7021 118.4491 114.3531 117.8374 115.7268 116.7954 C 117.1004 115.7534 118.1341 114.3274 118.6969 112.6977 C 119.2597 111.0681 119.3267 109.3079 118.8895 107.6402 C 118.4523 105.9724 117.5307 104.4718 116.2407 103.3288 C 114.9504 102.1844 113.3505 101.4489 111.6419 101.2153 C 109.9338 100.9809 108.195 101.2577 106.6449 102.0126 C 105.6154 102.513 104.6944 103.2117 103.9347 104.0681 C 103.175 104.9245 102.5922 105.9225 102.2185 107.0046 C 101.844 108.0863 101.6875 109.2316 101.7557 110.374 C 101.8248 111.5168 102.1179 112.6348 102.6193 113.6644 Z M 114.1892 108.0356 C 114.5485 108.7739 114.6812 109.6024 114.5696 110.4158 C 114.458 111.2291 114.1079 111.9912 113.5628 112.6054 C 113.0187 113.2199 112.3036 113.6587 111.5091 113.8667 C 110.7155 114.0751 109.8772 114.0431 109.1011 113.7749 C 108.325 113.5067 107.6465 113.0149 107.1504 112.3609 C 106.6534 111.7066 106.3624 110.9201 106.3134 110.1007 C 106.2645 109.2814 106.4593 108.4657 106.8737 107.7569 C 107.2872 107.0477 107.9027 106.4779 108.6414 106.1191 C 109.6312 105.6374 110.7722 105.5689 111.8129 105.928 C 112.8532 106.288 113.7082 107.0458 114.1892 108.0356 Z M 102.6438 106.0055 L 8.6241 110.2274 L 102.6105 113.6451 C 102.0334 112.4529 101.7365 111.1451 101.7428 109.8214 C 101.7483 108.4973 102.0565 107.192 102.6438 106.0055 Z M 118.0088 114.204 L 136.208 114.8688 L 133.5745 109.4563 L 136.6928 104.478 L 117.9002 105.3211 C 118.0405 105.5531 118.1747 105.7921 118.2956 106.041 C 118.9191 107.3217 119.219 108.7351 119.1687 110.1585 C 119.1187 111.5813 118.7206 112.9706 118.0088 114.204 Z")
        .attr("fill", "white")
        .attr("stroke-width", 2).attr("transform", `translate(-105, -120) rotate(${angle},106.6193, 114.6644)`)
        if(this.setParams > 2300){
          translatX = 15
        }
        }

        



    }

    homeScreen(){
      const controllerUuid = this.auth.encryptParams(this.controller_uuid);
      
      
      this.router.navigate([RouteConstants.ADMIN_CUSTOMER_ROUTES],{replaceUrl:true});
      this.router.navigate([
        RouteConstants.ADMIN_CUSTOMER_ROUTES],
  
        { queryParams:{
          controller: controllerUuid,
          user_id:this.encryptedUserId,
  
         replaceUrl: true }},
      );

    }


  ngOnInit(): void {
    this.getUserdetails()
    this.dasboardSwitchOnRefresh();
    if (this.reloaded === 0) {
    this.route.queryParams.subscribe(params => {
      const encryptedDeviceId = params['device'];
      const encryptedControllerUuid = params['controller'];
      const alarms = params["alarms"]
      this.encryptedUserId = params["user_id"]
  
      const deviceId = this.auth.decryptParams(encryptedDeviceId);
      const controllerUuid = this.auth.decryptParams(encryptedControllerUuid);
      
      // const deviceDetails = JSON.parse(deviceJson);
      this.device_id = deviceId;
      this.controller_uuid = controllerUuid;
      this.getControllerInfo(alarms)
      this.setAvailableMetrics(this.device_id);
      this.getDeviceSpecificTelemetry(this.selectedMetric)


    })};



  }



  async dasboardSwitchOnRefresh() {
    if( AppSessionStorageService.auth?.role == 'administrator'){
      this.isAdmin = true
    }
    if (
      !AppSessionStorageService.grantAccess &&
      AppSessionStorageService.auth?.role == 'administrator'
    ) {
      this.reloaded = 1;
      this.backToAdminDashboard();
      }
    return null;
  }

  backToAdminDashboard() {
    AppSessionStorageService.grantAccess = null
    this.router.navigate(['admin'],{replaceUrl:true});
  }








    async getControllerInfo(alarms?:boolean){
      const controller_info:ControllerInfo[]= await this.controller.getControllerInfo(this.controller_uuid)
      if(controller_info){
        this.controller_info = controller_info[0]
        this.deviceDetails = {"controller_uuid":this.controller_uuid,"device_id":this.device_id,"timeZone":this.controller_info.time_zone}
      }
      this.showAlarmPopup = !!alarms;
      
    }










  async getUserdetails():Promise<void>{
    this.auth.fetchUserDetails()
  }

  get fullName():string{
    return (AppSessionStorageService.user?.firstname ?? '') + ' ' + (AppSessionStorageService.user?.lastname ?? '');
    }
    
  get userName():string{
    return AppSessionStorageService.user?.username ?? '';
  }

  get userId():string{
    return AppSessionStorageService.user?.user_id ?? '';
  }


  get profileImage(): string {
    return this.auth.getUserImage() ?? 'assets/default-image.svg';
  }

  getSelectedMetricClass(){
    return{
      'selectedmetricid': this.device_id.includes('WaterMeter')
    }
  }


  async getDeviceSpecificHistory(controller_uuid: string, device_id: string, metric: string,   start?: string,
    stop?: string,
    aggregate_filter?: string, label?:string, graph_type?:string, graph_value?:string): Promise<void> {
    if (!this.streamCalled) {
      this.streamCalled = true;
      if (graph_type === "bar_graph"){
                aggregate_filter = ''

        if (graph_value){
        metric = graph_value
              }}






      this.deviceHistory = await this.controller.get_device_history(
        controller_uuid,
        device_id,
        metric,
        start,
        stop,
        aggregate_filter
      );




        const  controller_time_zone:string = this.controller_info!.time_zone
        const localizedData = this.deviceHistory.map((item: DeviceHistoryRecord) => ({
          timestamp: this.convertToLocalTime(item.timestamp, controller_time_zone),
          [metric]: item[metric]
        }));
        if (graph_type === "bar_graph"){
          this.drawBarGraph(localizedData, metric, label, graph_type)
        } else{
          this.drawLineGraph(localizedData, metric, label,aggregate_filter);
        }
        
      this.streamCalled = false;

    }
  }


  setAvailableMetrics(deviceId: string): void {
    const config = DEVICE_CONFIGS.find(d => d.id === deviceId);
    this.availableMetrics = config?.metrics ?? [];
    this.availableDateRanges = config?.dateRanges ?? [];

    // Set first available metric as selected
    this.selectedMetric = this.availableMetrics[0] ?? null;
  }

  getDeviceSpecificTelemetry(selected_vale:MetricOption | null){
      this.gaugeUnit= {"unit":selected_vale?.img_path?.unit}
    switch(selected_vale?.label){
      case "Outlet temperature":
        const gaugeOutletParams:GaugeChartInterface = {"fieldList":["outlet_temperature"],"selectedValue":selected_vale,"arcWidth":50,"gaugeSegmentModel":[7,37,4],"yAxis":-5,"yAxisLabel":20}
        this.setParams = 0
        this.gaugeChart(gaugeOutletParams)
        break
      case "Inlet temperature":
        const gaugeInletParmaters:GaugeChartInterface = {"fieldList":["set_temperature","temperature"],"selectedValue":selected_vale,"arcWidth":50,"gaugeSegmentModel":[7,37,4],"yAxis":-5,"yAxisLabel":20}
        this.gaugeChart(gaugeInletParmaters)
        break
      case "Motor speed":
        const gaugeMotorParmaters:GaugeChartInterface = {"fieldList":["set_speed","rpm"],"selectedValue":selected_vale,"arcWidth":3000,"gaugeSegmentModel":[],"yAxis":60,"yAxisLabel":90}
        this.gaugeChart(gaugeMotorParmaters)
        break
      case "Ph":
        const gaugePhParmaters:GaugeChartInterface = {"fieldList":["set_ph","ph"],"selectedValue":selected_vale,"arcWidth":14,"yAxis":-5,"yAxisLabel":20}
        if(this.device_id == "SaltChlorinator"){
          gaugePhParmaters.gaugeSegmentModel = [6.55,1.4,5.55]
          this.gaugeChart(gaugePhParmaters)
        }
        else{
          gaugePhParmaters.gaugeSegmentModel = [6.3,1.2,5.9]
          this.gaugeChart(gaugePhParmaters)
        }
        break
      case "Orp":
        const gaugeOrpParmaters:GaugeChartInterface = {"fieldList":["set_orp","orp"],"selectedValue":selected_vale,"arcWidth":1000,"gaugeSegmentModel":[380,385,195],"yAxis":-5,"yAxisLabel":20}
        this.gaugeChart(gaugeOrpParmaters)
        break
      case "Salt":
        const gaugeSaltParmaters:GaugeChartInterface = {"fieldList":["salt"],"selectedValue":selected_vale,"arcWidth":5,"gaugeSegmentModel":[1.4,1,2.4],"yAxis":-5,"yAxisLabel":20}
        this.setParams = 0
        this.gaugeChart(gaugeSaltParmaters)
        break
      case "Status":
        this.gpioDeviceTelemeteryStatus()
        break


      default:
        this.getEntriesWithoutGauge(selected_vale)
        break
    }
    
  }

  get deviceSpecificDatepicker(){
    return !this.showDatePicker.includes(this.selectedMetric!.label)
  }

  historyScreen(){
    this.telemetryView = false
    this.historyScreenBool = true
    if (this.selectedMetric) {
      this.selectedDateRange = this.availableDateRanges[0];

      const { start, stop } = this.getDateRange(this.selectedDateRange.label, this.selectedDateRange.aggregate_filter);
      this.getDeviceSpecificHistory(this.controller_uuid, this.device_id, this.selectedMetric.value,start,stop,this.selectedDateRange.aggregate_filter,this.selectedDateRange.label,this.selectedMetric.graph_type, this.selectedMetric.graph_value );
    }
  }

  async getEntriesWithoutGauge(selected_vale:MetricOption | null){
    this.telemetryView = false
    this.spinner = true
    const telemetryApiResp:TelemetryDetails = await this.controller.telemeteryGet(this.controller_uuid,this.device_id,[selected_vale!.value])
    this.spinner = false
    const selectedFieldList = this.selectedParametersFiltering(telemetryApiResp.result,selected_vale!.value)
    if(selectedFieldList[0] == 0 && selected_vale?.value == "pool_cover_status" ){
      this.telemetryDetails = {"value":selectedFieldList[0],"img":this.statusDevice === "turn_off"?selected_vale?.img_path2_off?.path :selected_vale?.img_path2?.path,"unit":selected_vale?.img_path2?.unit}
    }

    else{
      this.telemetryDetails = {"value": selected_vale?.value === "cell_life" 
                ? Math.trunc(selectedFieldList[0]) 
                : Number(selectedFieldList[0].toFixed(1)),
        "img": this.statusDevice === "turn_off"?selected_vale?.img_path_off?.path :selected_vale?.img_path?.path,
        "unit": selected_vale?.img_path?.unit
      };

    }


  }

  get getTelemetryNull(){
    return this.showTelemeteryForDevices.includes(this.device_id)
  }

  selectedParametersFiltering(result:TelemetryValue[],selected_value:string){
    const outerDat= []
    const otherFields = result.find((data:TelemetryValue)=>{
      return data._field == selected_value
    })
    const setParameters = result.find((data:TelemetryValue) =>{
      return data._field.includes("set")
    })
    if(otherFields){
      this.otherFields = Number(otherFields!._value)
      outerDat.push(this.otherFields)
    }
    if(setParameters){
      this.setParams = Number(setParameters?._value)
      outerDat.push(this.setParams)
      }
    
    return (outerDat && outerDat.length > 0) ? outerDat : [0, 0];
  }

  onMetricChange(hasSelectedMetric:boolean): void {
    if(hasSelectedMetric){ 
      this.planModel = new Date(new Date().setHours(0, 0, 0, 0) );
      this.selectedDateRange = this.availableDateRanges[0];
      this.filteringDates(this.selectedMetric!.label)
    }
    if (!this.historyScreenBool){
      d3.select("#chart").select("#gauge").remove();
      this.getDeviceSpecificTelemetry(this.selectedMetric )
    }
   
    else if (this.selectedMetric && this.selectedDateRange && this.selectedDateRange.label != "CUSTOM") {
      const { start, stop, aggregate_filter } = this.getDateRange(this.selectedDateRange.label, this.selectedDateRange.aggregate_filter);
      this.getDeviceSpecificHistory(
        this.controller_uuid,
        this.device_id,
        this.selectedMetric.value,
        start,
        stop,
        aggregate_filter,
        this.selectedDateRange.label,
        this.selectedMetric.graph_type,
        this.selectedMetric.graph_value
      );
  }
  else{
    setTimeout(() => {
      this.datepicker?.open();
    });
    
   
  }
  }
  filteringDates(label:string){
    if(this.showDatePicker.includes(label) && this.copyAvailableDateRange.length < 1){
      this.copyAvailableDateRange = this.availableDateRanges
      this.availableDateRanges = this.availableDateRanges.filter((value =>{
        return !value.parameters?.includes(this.selectedMetric!.label)
      }))

    }
    else if (this.copyAvailableDateRange.length > 1){
      this.availableDateRanges = this.copyAvailableDateRange
      this.copyAvailableDateRange = []

    }

  }
  async gpioDeviceTelemeteryStatus(){
    this.telemetryView = false
    const currentDeviceStatus:DeviceDetais | undefined = await this.deviceStatus()
      const imagePath = GpioConfig.find((deviceStatus)=>{
        return deviceStatus.device_status == currentDeviceStatus?.device_status && deviceStatus.device_id == this.device_id
      })
      this.telemetryDetails = {"img":imagePath?.img}    
  }

  async deviceStatus(){
    const deviceStatus= await this.controller.getDeviceStatus(this.controller_uuid,this.device_id)
    const deviceDetails = deviceStatus.find((val)=>{
      return val.device_id == this.device_id && val.controller_uuid == this.controller_uuid && val.device_status?.includes("turn")
    })
    this.statusDevice = deviceDetails?.device_status
    this.spinner = false
    return deviceDetails
  }


  


  getDateRange(rangeType: string,aggregate_filter:string,filterStart?:any,filterStop?:any): { start: string; stop:  any; aggregate_filter: string } {
    let stop:Date = new Date();; // current UTC time
    const todayMidnight = new Date();
    todayMidnight.setHours(0, 0, 0, 0); // today 12:00 AM local
  
    let start: Date;
    // let aggregate_filter: string;
  
    switch (rangeType.toUpperCase()) {
      case 'TODAY':
        start = new Date(todayMidnight);
        // aggregate_filter = 'day';
        break;
  
      case 'YESTERDAY':
        start = new Date(todayMidnight);
        start.setDate(start.getDate() - 1);
        stop = new Date(todayMidnight.getTime() - 1); // one millisecond before today starts
        // aggregate_filter = 'day';
        break;
  
      case 'LAST WEEK':
        this.changeDateFormat = false
        start = new Date(todayMidnight);
        start.setDate(start.getDate() - 7);
        // aggregate_filter = 'week';
        break;
  
      case 'LAST MONTH':
        this.changeDateFormat = false
        start = new Date(todayMidnight);
        start.setMonth(start.getMonth() - 1);
        start.setDate(start.getDate() + 1); 
        // aggregate_filter = 'month';
        break;
  
      case 'LAST YEAR':
        start = new Date(todayMidnight);
        start.setFullYear(start.getFullYear() - 1);
        // aggregate_filter = 'year';
        break;
      case 'CUSTOM':
        start = filterStart
        const diffInMs:number = filterStop - filterStart;
        let diffInDays:number = Math.round(Math.abs(diffInMs / (1000 * 60 * 60 * 24)));
        const addedTime = 23 * 60 * 60 * 1000 + 59 * 60 * 1000;
        stop = new Date(filterStop ? filterStop.getTime() + (24 * 60 * 60 * 1000) - 1000: start.getTime() + addedTime)
        if(!filterStop){
          diffInDays = 0
        }
        aggregate_filter = this.getFilterForCustomRange(diffInDays)
        break
  
      default:
        start = new Date(todayMidnight);
        break;
    }
  
    return {
      start: start.toISOString(),
      stop: stop.toISOString(),
      aggregate_filter
    };
  }

  getFilterForCustomRange(diffInDays:number):string{
    const dayNumber= diffInDays + 1

  if (this.device_id == "VsPump"){
    return ""
  }
  this.changeDateFormat = false
  let filter = 'day';
   if(dayNumber< 2){
    filter = 'day';
   }
   else if(dayNumber <= 14){
    if (dayNumber > 7){
      this.changeDateFormat = dayNumber > 7
    }
    filter = 'week'
   }
   else if(dayNumber > 14 && dayNumber <=90){
    this.changeDateFormat = dayNumber > 14 && dayNumber <=90
    filter = 'month';
   }
   else if (dayNumber > 91) {
    filter = 'year';
  }
  return filter;

  }
  

onActionHistoryTap(){
  this.showAlarmPopup = false
  this.showActionPopUp = true;
  this.controllerDetails = {"device_id":this.device_id,"controller_uuid":this.controller_uuid,"time_zone":this.controller_info!.time_zone}
}


onNotificationClick(){
  this.showActionPopUp = false
  this.showAlarmPopup = true;

}



  closeModal(){
    this.showAlarmPopup = false
    this.showActionPopUp = false
    this.showCustomerPopUp = false

  }

  onProfileTap(){
    this.showCustomerPopUp = true
  }



  convertToLocalTime(utcTime: string, zone: string): string {
    return DateTime.fromISO(utcTime, { zone: 'utc' })
                   .setZone(zone)
                   .toFormat('yyyy-MM-dd HH:mm:ss'); // or customize format
  }


  drawLineGraph(localizedData: any[], metric: string, label?:string,aggregate_filter?:string,): void {
    this.noData = false;
    d3.select('#chart').selectAll('svg').remove();
    d3.select('#y-axis').selectAll('svg').remove();

    let width: number;

    const margin = { top: 20, right: 30, bottom: 30, left: 50 };
    if (localizedData.length <= 50){
      width = 2000 - margin.left - margin.right;
    } else {
      width = localizedData.length * 50; 
    }
    const height = 500 - margin.top - margin.bottom;
    const parent = d3.select('#chart')
    const yAxisSvg = d3.select("#y-axis")
    const yAxesSvg = yAxisSvg.append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .style('position', 'absolute')
    .style('pointer-events', 'none')
    const svg = parent
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);
  
    const parseTime = d3.timeParse("%Y-%m-%d %H:%M:%S");
    let reversedData: any[] = [];

    // for handling null values
    const filteredData = localizedData.filter(
      (d) => d[metric] !== null && d[metric] !== undefined
    );
      const dedupedData = filteredData.filter((d, i, arr) => {
        // Always keep the last item
        if ((i === 0) || (i === arr.length - 1)) return true;

        const current = d[metric];
        const previous = arr[i - 1][metric];

        // Deduplicate if same as previous
        return current !== previous;
      });


      if (!aggregate_filter){
        reversedData = dedupedData.slice().reverse();
      }else{
        reversedData = filteredData.slice().reverse();
      }

      
  
    
    reversedData.forEach(d => {
      d.timestamp = parseTime(d.timestamp);
    });
  

    const x = d3.scalePoint()
    .domain(reversedData.map(d => d.timestamp)) 
    .range([0, width]);
  
  const xAxis = d3.axisBottom(x)
  .tickFormat(d => {
    if (label === "LAST WEEK" || aggregate_filter == 'week' ) {
      if (this.changeDateFormat){
        return d3.timeFormat("%-d%b")(new Date(d));
      }
      return d3.timeFormat("%a")(new Date(d)); // "Sun", "Mon", "Tue", etc.
    } else if (label === "LAST YEAR" || aggregate_filter == 'year' ){
      let date: Date;
      if (typeof d === 'string') {
          date = new Date(d); 
      } else {
          date = d; 
      }
  
      const quarter = Math.floor(date.getMonth() / 3) + 1;
      return `Q${quarter} ${date.getFullYear()}`;
  }else if (label === "LAST MONTH" || aggregate_filter == 'month' ) {
      if (this.changeDateFormat){
        return d3.timeFormat("%-d%b")(new Date(d));
      }

    return d3.timeFormat("%-d")(new Date(d));
  }
      else {
      return d3.timeFormat("%-I:%M %p")(new Date(d)); // Default time format
    }
  }); 
  
  const maxValue = d3.max(reversedData, d => d[metric]) ?? 0;
  const yDomainMax = maxValue === 0 ? 1 : maxValue * 1.1;


  const y = d3.scaleLinear()
  .domain([0, yDomainMax])
    .range([height, 0]);
  
      yAxesSvg.append('g').attr('transform','translate(40,28)')
      .call(d3.axisLeft(y));
  
      const line = d3.line<any>()
      .x(d => x(d.timestamp)??0)
      .y(d => d[metric] === 0 ? y(0) : y(d[metric]))  // Explicit handling
      .curve(d3.curveLinear); // Use curveLinear for straight lines 
      let xAxisHeight = height
      if (!reversedData.length){
        xAxisHeight = xAxisHeight - 44 
        svg.append('g')
        .attr('transform', `translate(-45,${xAxisHeight})`)
        .call(xAxis);
        this.noData = true;
        return;
      }
      svg.append('g')
      .attr('transform', `translate(0,${xAxisHeight})`)
      .call(xAxis);


      svg.append('path')
      .datum(reversedData)
      .attr('fill', 'none')
      .attr('stroke', 'yellow') // Line color
      .attr('stroke-width', 2)   // Line width
      .attr('stroke-linejoin', 'miter') // Sharp corners
      .attr('d', line);  


  const tooltip = d3.select('body')
      .append('div')
      .attr('class', 'tooltip')
      .style('position', 'absolute')
      .style('opacity', 0)
      .style('pointer-events', 'none')
      .style('background', 'rgba(0, 0, 0, 0.7)')
      .style('color', '#fff')
      .style('border-radius', '4px')
      .style('padding', '5px')
      .style('font-size', '12px');
  
     //Use dedupedData for circles
    svg.selectAll('circle')
      .data(reversedData)
      .enter()
      .append('circle')
      .attr('r', 5)
      .attr('fill', 'white')
      .attr('cx', d => x(d.timestamp) ?? 0)
      .attr('cy', d => y(d[metric])) 
      .on('mouseover', function (event, d) {
        tooltip.transition()
          .duration(200)
          .style('opacity', 0.9);
        tooltip.html(`
          <strong>Time:</strong> ${d3.timeFormat("%-I:%M %p")(d.timestamp)}<br/>
          <strong>${metric}:</strong> ${d[metric].toFixed(1)}
        `);
      })
      .on('mousemove', function (event, d) {
        tooltip
          .style('left', (event.pageX + 10) + 'px')
          .style('top', (event.pageY - 28) + 'px');
      })
      .on('mouseout', function () {
        tooltip.transition()
          .duration(500)
          .style('opacity', 0);
      });
    }
    




  drawBarGraph(localizedData: any[], metric: string, label?:string, graph_type?:string): void {
    this.noData = false;
    d3.select('#chart').select('svg').remove();
    d3.select('#y-axis').selectAll('svg').remove();
    const parent = d3.select('#chart')
    const yAxisSvg = d3.select("#y-axis")
  
    const margin = { top: 20, right: 30, bottom: 30, left: 50 };
    let width = 2000 - margin.left - margin.right;
    const height = 500 - margin.top - margin.bottom;
    if (localizedData.length <= 50){
      width = 2000 - margin.left - margin.right;
    } else {
      width = localizedData.length * 50; 
    }
    
    const svg = parent
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

      const yAxesSvg = yAxisSvg.append('svg')
      .attr('width', width + margin.left   + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .style('position', 'absolute')
      .style('pointer-events', 'none')
  
    const parseTime = d3.timeParse("%Y-%m-%d %H:%M:%S");
    let reversedData: any[] = [];



    // for handling null values
    const filteredData = localizedData.filter(
      (d) => d[metric] !== null && d[metric] !== undefined
    );
    filteredData.reverse()


    filteredData.forEach(d => {
      d.timestamp = parseTime(d.timestamp);
    });
  

    const x = d3.scalePoint()
    .domain(filteredData.map(d => d.timestamp)) 
    .range([0, width]);
  
  const xAxis = d3.axisBottom(x)
  .tickFormat(d => {
    return d3.timeFormat("%-I:%M %p")(new Date(d));
  }); 
  
  const maxValue = d3.max(filteredData, d => d[metric]) ?? 0;
  const yDomainMax = maxValue === 0 ? 1 : maxValue * 1.1;


  const y = d3.scaleLinear()
  .domain([0, yDomainMax])
    .range([height, 0]);
  
      yAxesSvg.append('g').attr('transform','translate(40,28)')
      .call(d3.axisLeft(y));
      let xAxisHeight = height
      if (!filteredData.length){
        xAxisHeight = xAxisHeight - 44 
        svg.append('g')
        .attr('transform', `translate(0,${xAxisHeight})`)
        .call(xAxis);
        this.noData = true;
        return;
      }
      svg.append('g')
      .attr('transform', `translate(0,${xAxisHeight})`)
      .call(xAxis);


        let onSegments: any[] = [];
        let currentStart: Date | null = null;
        
      for (let i = 0; i < filteredData.length; i++) {
        const point = filteredData[i];
        const status = point[metric];

        if (status === 0) {
          // Start of an ON segment
          currentStart = point.timestamp;
        }
      

    if ((status === 1 || i === filteredData.length - 1) ) {
        // End of an ON segment
        const endTime = point.timestamp;
        onSegments.push({
          start: currentStart,
          end: endTime
        });
      }

    }

        // Draw bars for ON segments
        svg.selectAll(".bar")
          .data(onSegments)   // <-- Use onSegments here!
          .enter()
          .append("rect")
          .attr("class", "bar")
          .attr("x", d => x(d.start)??0)
          .attr("y", y(1))   // Assuming status "on" is visualized as y(1)
          .attr("width", d => Math.abs((x(d.end)??0) - (x(d.start)??0)))
          .attr("height", y(0) - y(1))
          .attr('fill', 'yellow');
          return;
      }
    }

